module.exports = __webpack_public_path__ + "img/EG.693ab385.jpg";